import { Pipe, PipeTransform } from '@angular/core';
import { TabItem } from '../tabs/tab-item.model';

@Pipe({
  name: 'UlaObjectValues'
})
export class UlaObjectValues implements PipeTransform {
  transform(obj: {}): Array<TabItem<void>> {
    let values = [];

    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        values.push(obj[key]);
      }
    }

    return values;
  }
}
